<template>
  <div class="daily-report">
     <reportSelectRatio></reportSelectRatio>
  </div>
</template>

<script>
import reportSelectRatio from './reportSelectRatio.vue'
export default {
  name: 'dailyReport',
  components:{
    reportSelectRatio
  },
  data() {
    return {

    }
  },

}
</script>

<style scoped lang="scss">
.daily-report {
  font-size: 1rem;
  width: 100%;
  padding-top: 20px;
}
</style>
